import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { endPoint, getAllCategory } from "../../components/Api/Api";
import Swal from "sweetalert2";
import { useQuery } from "@tanstack/react-query";
const UploadPage = () => {

  const getCategories = useQuery({
    //  queryKey : ["allcategories"],
    queryFn : getAllCategory
   
  })

  

  const categories = getCategories?.data?.data
  const navigate = useNavigate();
  const [productImage, setProductImage] = useState("");
  const [title, setTitle] = useState("");
  const [preview, setPreview] = useState("");
  const [desc, setDesc] = useState("");
  console.log(setDesc)
  const [price, setPrice] = useState<any>(0);
  const [quantity, setQuantity] = useState<any>(0);
  const [category , setCategory] = useState("")

  const handleImage = (e: any) => {
    const file = e.target.files![0];
    console.log(file);
    const previewUrl = URL.createObjectURL(file);

    setProductImage(file);
    setPreview(previewUrl);
    console.log(preview);
  };

  const uploadData = async () => {
    const formData = new FormData();

    formData.append("title", title);
    formData.append("productImage", productImage);
    formData.append("desc", desc);
    formData.append("quantity", quantity);
    formData.append("price", price);
    formData.append("category", category);

    await axios
      .post(`${endPoint}/products/new-product`, formData)
      .then((res) => {
        console.log(res)
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Product Uploaded successfully ",
          showConfirmButton: false,
          timer: 2500,
        });
     
        navigate("/product");
      
      });
  };

  return (
    <Container>
      <Wrapper>
        <Card>
        

          <Circle>
            <Img src={preview} />
          </Circle>

          <Input onChange={handleImage} id="pix" type="file" />
          <Button htmlFor="pix">Upload Cover Image</Button>

          <Inp
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setTitle(e.target.value);
            }}
            placeholder="Enter Title"
          />
          {/* <TexArea
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              setDesc(e.target.value);
            }}
            placeholder="Summary..."
          /> */}
          <Inp
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setPrice(e.target.value);
            }}
            placeholder="Enter Price" type="number"
          />
          <Inp
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setQuantity(e.target.value);
            }}
            placeholder="Set the available quantity" type="number"
          />


          <Select
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              setCategory(e.target.value);
              // console.log("thisis category value" , category)
            }}
          >
          <option>select a category</option>
            {
             categories?.map((el:any)=>(
              <option>{el?.name}</option>
             )) 
            }
         
          </Select>

          {title !== "" &&
          productImage !== "" &&
         
          price !== "" &&
          quantity !== "" ? (
            <Button2 onClick={uploadData} cp="pointer" bg="black">
              Submit
            </Button2>
          ) : (
            <Button2 cp="not-allowed" bg="silver">
              Submit
            </Button2>
          )}
        </Card>
      </Wrapper>
    </Container>
  );
};

export default UploadPage;

const Img = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Button2 = styled.button<{ bg: string; cp: string }>`
  height: 40px;
  width: 150px;
  background-color: ${(props) => props.bg};
  color: white;
  border: none;
  outline: none;
  border-radius: 5px;
  transition: all 350ms;
  cursor: ${(props) => props.cp};
  margin-top: 10px;
  :hover {
    transform: scale(0.95);
  }
  @media screen and (max-width: 500px) {
    width: 120px;
  }
`;

const Select = styled.select`
  width: 370px;
  height: 30px;
  border-radius: 3px;
  border: 0.7px solid silver;
  outline-color: #f8cbe0;
  padding-left: 10px;

  @media screen and (max-width: 500px) {
    width: 265px;
  }
`;


const Inp = styled.input`
  margin: 10px;
  width: 350px;
  height: 30px;
  border-radius: 3px;
  border: 0.7px solid silver;
  outline-color: #f8cbe0;
  padding-left: 10px;

  @media screen and (max-width: 500px) {
    width: 265px;
  }
`;

const Input = styled.input`
  display: none;
`;
const Button = styled.label`
  height: 40px;
  width: 200px;
  background-color: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  transition: all 350ms;
  margin-top: 10px;
  cursor: pointer;
  :hover {
    transform: scale(0.98);
  }
`;

const Circle = styled.div`
  height: 150px;
  width: 250px;
  border-radius: 5px;
  /* border-radius: 50%; */
  background-color: #e6e4e4;
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  flex-direction: column;
  font-size: 30px;
  span {
    font-size: 12px;
  }
`;

const Card = styled.div`
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  width: 600px;
  /* height: 300px; */
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;

  @media screen and (max-width: 500px) {
    width: 270px;
  }
`;

const Wrapper = styled.div``;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;